import { Button, type ButtonProps, CircularProgress } from '@mui/material';
import { PureComponent } from 'react';
import styled from 'styled-components';

const StyledButton = styled(Button)`
  width: fit-content;
  .MuiButton-startIcon {
    height: 100%;
  }
`;

export type LoaderButtonSpecificProps = {
  readonly loading?: boolean;
  readonly disabled?: boolean;
};

export type LoaderButtonProps = LoaderButtonSpecificProps & ButtonProps;

export default class LoaderButton extends PureComponent<LoaderButtonProps> {
  public override render(): JSX.Element {
    const { loading, disabled, ...props } = this.props;
    let icon;
    if (loading) {
      icon = <CircularProgress data-testid="loader-button-progress" size="1.25rem" color="inherit" />;
    }

    return (
      <StyledButton variant="contained" disableElevation disabled={disabled ?? loading} startIcon={icon} {...props} />
    );
  }
}
